// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "3f7da9e",
    "hash": "3f7da9e",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "3f7da9e",
    "semverString": null,
    "version": "0.0.0"
};
/* tslint:enable */
